import React from 'react';
import { Select } from '../../../../../../../styleguide';
import AceEditor from 'react-ace';
import { Input } from 'antd';
import 'brace/theme/monokai';
import 'brace/mode/javascript';


const { Option } = Select;

const CustomJS = ({
  value,
  settingsTitle,
  settingKey,
  updateSetting,
  neutralStateDisabled
}) => {
  return (
    <>
    <h5>Custom Javascript</h5>
    <div style={{ width: '100%', padding: '0 5px', position: 'relative' }}>
      <AceEditor
        value={value}
        mode='javascript'
        theme='monokai'
        readOnly={neutralStateDisabled || false}
        width='100%'
        height="200px"
        focus={!neutralStateDisabled}
        onChange={(value) => updateSetting(settingKey, value)}
        style={{ opacity: neutralStateDisabled ? 0.5 : 1 }}
      />
      {neutralStateDisabled && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            cursor: 'not-allowed',
            zIndex: 1
          }}
        />
      )}
    </div>
  </>
  );
};


export default CustomJS;